export default __webpack_public_path__ + "static/media/untitled_design_16.e8cc8816.png";